import * as React from 'react';
import * as ReactDOM from 'react-dom';
// umijs/hooks隐性依赖于regenerator-runtime
import 'regenerator-runtime/runtime';
import { Suspense, useEffect, useState } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { store } from 'store/root';
import { ConfigProvider } from 'antd';
import { ConfigProvider as ConfigProvider4 } from 'antd4';
import Empty from 'components/Empty';
import './reset.less';
import './public.less';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';
import 'moment/locale/ru';
import './i18n';
import { PageLoading } from 'components/Loading';
import i18next from 'i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Inspector, InspectParams } from 'react-dev-inspector';
import { advertCvtColConvert } from 'utils/temp/advertColumn';
import PageViewReport from 'components/PageViewReport';
import { CURRENT_LANGUAGE, CURRENT_LOCALE } from './constants/global';
import routerConfig from './routes/router.config';
import { ROOT_INIT } from './sagas/root';
import { GET_PEAR_CONFIG_DICTS, INIT_NAV_MENU } from './store/global';
import 'utils/sentry';
import { history, getRoutes } from './routes';
import registerServiceWorker from './registerServiceWorker';

const InspectorWrapper = process.env.NODE_ENV === 'development' ? Inspector : React.Fragment;

if (window.location.protocol.includes('https')) {
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  meta.content = 'upgrade-insecure-requests';
  document.head.appendChild(meta);
}

function Page() {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    // 有登录状态时读取用户的语言配置，否则优先读取缓存，再读取浏览器语言
    const exportPath = routerConfig.filter((config) => config.path !== '/').map((config) => config.path);
    if (exportPath.includes(window.location.pathname)) {
      initLanguage();
    } else {
      dispatch({ type: ROOT_INIT, payload: initLanguage });
    }
  }, []);

  return !visible ? (
    <div />
  ) : (
    <ConfigProvider4 prefixCls='ant4'>
      <ConfigProvider renderEmpty={Empty} locale={CURRENT_LOCALE.locale}>
        <ConnectedRouter history={history}>
          <PageViewReport />
          {getRoutes(store)}
        </ConnectedRouter>
      </ConfigProvider>
    </ConfigProvider4>
  );

  function initLanguage() {
    i18next.changeLanguage(CURRENT_LANGUAGE, () => {
      setVisible(true);

      // 初始化导航菜单，过滤掉无权限的那些
      dispatch({ type: INIT_NAV_MENU });
      // 登录页跳转注册/忘记密码需要获取路径
      dispatch({ type: GET_PEAR_CONFIG_DICTS });
    });
  }
}

ConfigProvider4.config({ prefixCls: 'ant4' });

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<PageLoading />}>
      <InspectorWrapper
        // props docs see:
        // https://github.com/zthxxx/react-dev-inspector#inspector-component-props
        // 自定义自己的快捷按键，如果不出现，可以鼠标点一下页面再重试
        keys={['control', 'command', 'x']}
        disableLaunchEditor={false}
        onHoverElement={(params: InspectParams) => {}}
        onClickElement={(params: InspectParams) => {}}
      >
        <Page />
      </InspectorWrapper>
    </Suspense>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

registerServiceWorker();

// TODO:下个需求就可以删除
advertCvtColConvert();
